import { Component, ViewChild, TemplateRef, OnInit, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { SnotifyService } from 'ng-snotify';

import DayGridPlugin from '@fullcalendar/daygrid';
import TimeGridPlugin from '@fullcalendar/timegrid';
import InteractionPlugin from '@fullcalendar/interaction';
import ResourceTimelinePlugin from '@fullcalendar/resource-timeline';
import { View } from '@fullcalendar/core/View';
import ListPlugin from '@fullcalendar/list';
import { FullCalendarComponent } from '@fullcalendar/angular';
import { PackageScheduleService } from './package-schedule.service';
import { EventInput } from '@fullcalendar/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Package } from 'src/app/shared/models/package.model';
import { PackageAggregator, DayStatus } from './helpers';
import { Traveler } from 'src/app/shared/models/traveler.model';


@Component({
  selector: 'app-package-schedule',
  templateUrl: './package-schedule.component.html',
  styleUrls: ['./package-schedule.component.scss'],
})
export class PackageScheduleComponent implements OnInit, AfterViewInit {

  calendarEvents: EventInput = [];
  calendarPlugins = [
    DayGridPlugin,
    TimeGridPlugin,
    InteractionPlugin,
    ListPlugin
  ];

  get packageId() {
    return this._packageId;
  }
  set packageId(id: number) {
    this._packageId = id;
  }
  private _packageId: number;


  packageAggregator: PackageAggregator;

  package: Package;

  packagesList: Package[] = [];

  selectModel: any;

  modalProps = {
    ref: null as NgbModalRef,
    date: null as Date,
    events: [],
    status: 'BLOCKED' as DayStatus
  };

  @ViewChild('calendar', {static: true}) calendar: FullCalendarComponent;
  @ViewChild('modalTemplate', {static: true, read: TemplateRef}) modalTemplate: TemplateRef<any>;
  constructor(
    private notifier: SnotifyService,
    private route: ActivatedRoute,
    private packageService: PackageScheduleService,
    private modalService: NgbModal,
    private router: Router
  ) {
    this.route.params.subscribe(params => {
      if (params.id) {
        this.packageId = Number(params.id);
        if (this.packageAggregator) {
          this.packageAggregator.packagesFilter.next(this.packageId);
        }
        this.selectModel = this.packageId;
      } else {
        this.packageId = null;
        this.selectModel = 'all';
        if (this.packageAggregator) {
          this.packageAggregator.packagesFilter.next(null);
        }
      }
    });
  }

  ngOnInit() {
    this.getAllPackages();
  }

  ngAfterViewInit() {

  }

  refreshAggregatorPackages() {
    this.packageAggregator.collectEvents();
  }

  selectChange(newVal) {
    if (newVal === 'all') {
      this.router.navigate(['/packages/schedule']);
    } else {
      this.router.navigate(['/packages/schedule/' + newVal]);
    }
  }


  dateClickHandler(event: DateClickInterface) {
    this.modalProps.date = event.date;
    this.modalProps.events = this.packageAggregator.getEventsAtDate(event.date);
    this.modalProps.status = this.packageAggregator.checkDayStatus(event.date);
    this.showModal();
  }

  hideModal() {
    if (this.modalProps.ref) {
      this.modalProps.ref.dismiss();
    }
  }

  modalAction(event) {
    switch (event.action) {
      case 'block': {
        this.addBlockedDay(this.modalProps.date.toISOString());
        break;
      }
      case 'unblock': {
        this.unblockDay(this.modalProps.date.toISOString(), event.value);
        break;
      }
      case 'blockTime': {
        this.addBlockedDay(this.modalProps.date.toISOString(), event.value);
      }
    }
    this.hideModal();
  }

  private initAggregator(ids) {
    this.packageAggregator = new PackageAggregator(ids, this.packageService);
    this.packageAggregator.events.subscribe(value => {
      this.calendarEvents = value;
    });

    if (this.packageId) {
      this.packageAggregator.packagesFilter.next(this.packageId);
    }
  }


  private unblockDay(day: string, extras?: any) {
    this.packageAggregator.unblockDay(day, extras);
  }

  private addBlockedDay(day: string, extras?: any) {
    this.packageAggregator.blockDay(day, extras);
  }

  private getAllPackages() {
    this.packageService.getAllPackages().then(response => {
      this.packagesList = response.data.experiences;
      this.initAggregator(
        this.packagesList
      );
    }).catch(error => {
      this.notifier.error('Something went wrong, please try again later!');
    });
  }
  private showModal() {
    this.modalProps.ref = this.modalService.open(this.modalTemplate, {
      windowClass: 'animated fadeIn',
    });
  }
}

interface DateClickInterface {
  date: Date;
  dateStr: string;
  dayEl: Element;
  jsEvent: MouseEvent;
  view: View;
}
